import { Text, Group, Badge } from "@mantine/core";
import { ColumnDef, createColumnHelper } from "@tanstack/react-table";
import ContextMenuRow from "./ContextMenuRow";

const columnHelper = createColumnHelper<TLicenciada>();

const columns: ColumnDef<TLicenciada>[] = [
  columnHelper.accessor("status", {
    header: "Status",
    enableSorting: true,
    cell: (properties) => {
      const status = properties.getValue();
      const isActive = status === "ATIVO" || status === "ativo";
      return (
        <Badge color={isActive ? "green" : "red"} variant="light">
          {status || "ATIVO"}
        </Badge>
      );
    }
  }),
  columnHelper.accessor("cnpj", {
    header: "CNPJ",
    enableSorting: true
  }),
  columnHelper.accessor("razaoSocial", {
    header: "Razão Social",
    enableSorting: true
  }),
  columnHelper.accessor("responsavel", {
    header: "Responsável",
    enableSorting: true,
    cell: (properties) => properties.getValue()?.nome
  }),
  columnHelper.accessor("endereco", {
    header: "Cidade/UF",
    enableSorting: false,
    cell: (properties) => {
      const endereco = properties.getValue();
      if (!endereco) return "-";
      return `${endereco.cidade}/${endereco.estado}`;
    }
  }),
  columnHelper.accessor("acessos", {
    header: "Acessos",
    enableSorting: false,
    cell: (properties) => {
      const acessos = properties.getValue();
      if (!acessos) return "-";
      const total =
        (acessos.admin || 0) +
        (acessos.member || 0) +
        (acessos.team || 0) +
        (acessos.master || 0) +
        (acessos.collaborator || 0);
      return <Text size="sm">{total} acessos</Text>;
    }
  }),
  columnHelper.display({
    id: "actions",
    cell: (properties) => {
      const licenciada = properties.row.original;
      return (
        <Group justify="center" gap={2}>
          <ContextMenuRow licenciada={licenciada} />
        </Group>
      );
    }
  })
];

export default columns;
